<template>
  <div class="container">
    <UserCenterSkeleton v-if="isLoading" />
    <div v-else>
      <div class="switch_btn" @click="switchVisible = true">
        Switch identities
        <img src="@/assets/images/switch.svg" alt="" />
      </div>
      <template v-if="userCenterInfo.type == 'seeker'">
        <div class="user_section user_info">
          <img
            @click="editVisible = true"
            :src="userCenterInfo.headUrl"
            alt=""
            class="avatar"
            @error="setDefaultImage($event, 'seeker')"
          />
          <div @click="editVisible = true" class="user_info_content">
            <span v-if="userCenterInfo.firstName && userCenterInfo.lastName" class="name">
              {{ userCenterInfo.firstName + ' ' + userCenterInfo.lastName }}
            </span>
            <span v-else class="name edit">
              Please enter your name
              <img src="@/assets/images/edit.svg" alt="" class="edit_icon" />
            </span>
            <div class="count_wrapper">
              <span>
                <img src="@/assets/images/favorite.svg" />
                <span class="count">{{ userCenterInfo.favoriteCount }}</span>
              </span>
              <span>
                <img src="@/assets/images/like_yellow.svg" />
                <span class="count">{{ userCenterInfo.likeCount }}</span>
              </span>
            </div>
          </div>
          <router-link class="action_btn" to="/userCenter/accountManagement">
            Account Management
            <img src="@/assets/images/arrow_right.svg" />
          </router-link>
        </div>
        <div class="user_section">
          <span class="resume_score">
            Current resume score: <span class="score">{{ userCenterInfo.resumeScore }}</span>
          </span>
          <a href="" class="action_btn" @click.prevent="handleLinkToEditResume">
            Edit Resume
            <img src="@/assets/images/arrow_right.svg" />
          </a>
        </div>
        <div class="user_section">
          <img class="tip_icon" src="@/assets/images/stay_turned.svg" />
          <span class="tip">
            More features are under development, please stay tuned
          </span>
        </div>
      </template>
      <template v-else-if="userCenterInfo.type == 'recruiter'">
        <div class="user_section user_info">
          <img
            @click="editVisible = true"
            :src="userCenterInfo.headUrl"
            alt=""
            class="avatar"
            @error="setDefaultImage"
          />
          <div @click="editVisible = true">
            <span v-if="userCenterInfo.firstName && userCenterInfo.lastName" class="name">
              {{ userCenterInfo.firstName + ' ' + userCenterInfo.lastName }}
            </span>
            <span v-else class="name edit">
              Please enter your name
              <img src="@/assets/images/edit.svg" alt="" class="edit_icon" />
            </span>
            <div class="company">{{ companyInfo.name }} Recruiter</div>
          </div>
          <router-link class="action_btn" to="/userCenter/accountManagement">
            Account Management
            <img src="@/assets/images/arrow_right.svg" />
          </router-link>
        </div>
        <!-- <div class="user_section">
        <span class="job"><span class="count">0</span>positions are currently open</span>
        <span class="action_btn">
          Manage My Jobs
          <img src="@/assets/images/arrow_right.svg" />
        </span>
      </div> -->
        <div v-if="companyInfo.name" class="user_section company_info" style="margin: 30px auto;">
          <img src="@/assets/images/company_icon.svg" alt="" class="company_icon" />
          <div>
            <span class="name">
              {{ companyInfo.name }}
            </span>
            <div v-if="companyInfo.status == 2" class="cert">
              <span>
                Business Certified
                <img src="@/assets/images/certified.svg" alt="" class="cert_icon" />
              </span>
            </div>
          </div>
          <router-link class="action_btn" to="/userCenter/enterpriseInformation">
            Company homepage
            <img src="@/assets/images/arrow_right.svg" />
          </router-link>
        </div>
        <div
          v-else
          class="user_section company_info"
          style="margin:30px auto;cursor:pointer;"
          @click="handleOpenBusinessVerifyModal"
        >
          <img src="@/assets/images/company_icon.svg" alt="" class="company_icon" />
          <div>
            <span class="name company_complete">
              Please complete enterprise authentication
            </span>
            <div class="cert company_tip">
              After completion, you can access the job seeker's contact information and save their resume
            </div>
          </div>
          <span class="action_btn">
            <img src="@/assets/images/arrow_right.svg" />
          </span>
        </div>
        <div class="resume_section" v-if="resumeList.length > 0">
          <div class="title">Saved Resumes</div>
          <div class="resume_wrapper">
            <div
              v-for="item in resumeList"
              :key="item.resumeId"
              class="resume_card"
              @click="handleOpenRusumeDetail(item)"
            >
              <div class="info_wrapper">
                <div class="info">
                  <div class="name">{{ item.displayName }}</div>
                  <div class="type">{{ item.jobStatus }}<span style="margin: 0 4px;">|</span>{{ item.city }}</div>
                </div>
                <img
                  :src="item.headUrl || ''"
                  alt=""
                  class="avatar"
                  crossorigin="anonymous"
                  @error="(e) => setDefaultImage(e, 'seeker')"
                />
              </div>
              <div class="tag_wrapper">
                <div class="tag" v-for="(skill, index) in item.skillList" :key="index">
                  {{ skill }}
                </div>
              </div>
              <div class="introduce">{{ item.advantage }}</div>
            </div>
          </div>
        </div>
      </template>
      <a-modal
        class="user_center_modal"
        width="400px"
        v-model:open="switchVisible"
        @cancel="handleSwitchCancel"
        :footer="null"
      >
        <div v-if="userCenterInfo.type === 'seeker'" class="switch_content">
          <img src="@/assets/images/recruiter.svg" class="switch_icon" alt="" />
          <div class="text">Change role to "Recruiter"</div>
        </div>
        <div v-else class="switch_content">
          <img src="@/assets/images/seeker.svg" class="switch_icon" alt="" />
          <div class="text">Change role to "job applicant"</div>
        </div>
        <div class="btn_wrapper">
          <a-button class="cancel_btn" @click="handleSwitchCancel">Cancel</a-button>
          <a-button class="confirm_btn" type="primary" @click.prevent="handleSwitch" :disabled="isSubmitDisabled">
            Done
          </a-button>
        </div>
      </a-modal>
      <a-modal
        class="user_center_modal"
        title="Enter personal information"
        v-model:open="editVisible"
        @cancel="editVisible = false"
        :footer="null"
      >
        <div class="tip">Information displayed during communication with job seekers</div>
        <div class="avatar_wrapper">
          <div class="avatar" @click="handleUploadClick" :style="{ cursor: isUploading ? 'not-allowed' : 'pointer' }">
            <img :src="formState.headUrl" alt="" @error="setDefaultImage" />
            <div v-if="isUploading" class="avatar_loading">
              <div class="loading_spinner"></div>
            </div>
          </div>
          <div class="update" @click="handleUploadClick" :style="{ cursor: isUploading ? 'not-allowed' : 'pointer' }">
            Update photo
          </div>
          <input type="file" ref="jdInput" style="display:none" @change="handleFileChange" accept="image/*" />
        </div>
        <a-form ref="formRef" :model="formState" class="modal_form">
          <div class="flex_box">
            <a-form-item
              validateTrigger="blur"
              label=""
              name="firstName"
              :rules="[{ required: true, message: 'Enter firstName' }]"
            >
              <a-input v-model:value="formState.firstName" placeholder="First Name" :maxlength="20" />
            </a-form-item>
            <a-form-item
              validateTrigger="blur"
              label=""
              name="lastName"
              :rules="[{ required: true, message: 'Enter lastName' }]"
            >
              <a-input v-model:value="formState.lastName" placeholder="Last Name" :maxlength="20" />
            </a-form-item>
          </div>
          <div class="flex_box">
            <a-form-item
              validateTrigger="blur"
              label=""
              name="nickName"
              :rules="[{ required: formState.useNicknameInResume, message: 'Enter nickName' }]"
            >
              <a-input v-model:value="formState.nickName" placeholder="Nick Name" :maxlength="20" />
            </a-form-item>
            <a-form-item class="switch_item" validateTrigger="blur" label="">
              <a-switch v-model:checked="formState.useNicknameInResume" />
              <span class="switch_tips">Using a nickname in a resume</span>
            </a-form-item>
          </div>
        </a-form>
        <a-button
          class="confirm_btn"
          type="primary"
          @click.prevent="handleUpadateUser"
          :disabled="isSubmitDisabled"
          style="margin: 0 auto;width: 100%;"
        >
          Done
        </a-button>
      </a-modal>
      <a-modal
        class="resume_detail_modal"
        v-model:open="resumeModalVisible"
        title=""
        @cancel="resumeModalVisible = false"
        width="800px"
        :footer="null"
      >
        <ResumePreview
          ref="ResumePreviewRef"
          :resumeToken="resumePreviewToken"
          :isShowAction="true"
          @on-upload="getFavoriteResumeList"
        />
      </a-modal>
      <BusinessVerifyModal ref="BusinessVerifyModalRef" @verify_success="handleVerifySuccess" />
      <ResumeGuideModal ref="ResumeGuideModalRef" />
      <a-modal
        class="user_center_modal"
        title="Crop Avatar"
        v-model:open="cropperVisible"
        @cancel="cropperVisible = false"
        :footer="null"
      >
        <ImageCropper
          v-if="cropperVisible"
          :image-file="selectedImageFile"
          @confirm="handleCropperConfirm"
          @cancel="handleCropperCancel"
        />
      </a-modal>
    </div>
  </div>
</template>

<script setup>
import { message } from 'ant-design-vue';
import { onMounted, reactive, ref } from 'vue';
import { useRouter } from 'vue-router';

import { upload } from '@/api/common.js';
import { fetchResumeInfo } from '@/api/resume.js';
import { fetchResumeListByToken } from '@/api/home.js';
import {
  fetchUserCenterInfo,
  changeRole,
  updateUserInfo,
  fetchFavoriteList,
  fetchCompanySimple,
} from '@/api/userCenter.js';
import BusinessVerifyModal from '@/components/BusinessVerifyModal.vue';
import ImageCropper from '@/components/ImageCropper.vue';
import ResumeGuideModal from '@/components/ResumeGuideModal.vue';
import ResumePreview from '@/components/ResumePreview.vue';
import UserCenterSkeleton from '@/components/UserCenterSkeleton.vue';

const userCenterInfo = reactive({
  employeeId: '',
  firstName: '',
  lastName: '',
  nickName: '',
  useNicknameInResume: '',
  resumeId: 1,
  resumeTitle: '',
  resumeScore: 0,
  likeCount: 0,
  favoriteCount: 0,
  companyId: null,
  companyName: null,
  companyStatus: null,
  type: '',
  headUrl: '',
});
const isLoading = ref(true);
const router = useRouter();

const switchVisible = ref(false);
const editVisible = ref(false);
const isUploading = ref(false);
const cropperVisible = ref(false);
const selectedImageFile = ref(null);

const handleSwitch = () => {
  changeRole({
    loginDevice: 1,
    type: userCenterInfo.type === 'seeker' ? 'recruiter' : 'seeker',
    keepLogin: true,
  }).then((res) => {
    if (res.code == 0) {
      window.location.reload();
    } else {
      message.error(res.msg);
    }
  });
};

const handleSwitchCancel = () => {
  switchVisible.value = false;
};

const getUserCenterInfo = () => {
  fetchUserCenterInfo().then((res) => {
    if (res.code == 0) {
      userCenterInfo.type = res.data.type;
      userCenterInfo.firstName = res.data.firstName;
      userCenterInfo.lastName = res.data.lastName;
      userCenterInfo.headUrl = res.data.headUrl;
      userCenterInfo.nickName = res.data.nickName;
      userCenterInfo.useNicknameInResume = res.data.useNicknameInResume;
      formState.firstName = res.data.firstName;
      formState.lastName = res.data.lastName;
      formState.headUrl = res.data.headUrl;
      formState.nickName = res.data.nickName;
      formState.useNicknameInResume = res.data.useNicknameInResume;
      if (res.data.type === 'seeker') {
        userCenterInfo.likeCount = res.data.likeCount || 0;
        userCenterInfo.favoriteCount = res.data.favoriteCount || 0;
        userCenterInfo.resumeScore = res.data.resumeScore || 0;
      } else {
        getFavoriteResumeList();
        getCompanyInfo();
      }
    } else {
      message.error(res.msg);
    }
    isLoading.value = false;
  });
};

const resumeList = ref([]);
const getFavoriteResumeList = () => {
  fetchFavoriteList().then((res) => {
    if (res.code == 0) {
      const list = res.data || [];
      // 收藏列表接口只返回精简数据（无 headUrl），需要用 token 批量查询完整简历信息获取头像
      const tokens = list.map((item) => item.token).filter(Boolean);
      if (tokens.length === 0) {
        resumeList.value = list;
        return;
      }
      fetchResumeListByToken({ pageSize: tokens.length, pageNum: 1, tokens })
        .then((detailRes) => {
          if (detailRes.code === 0 && detailRes.data && detailRes.data.list) {
            // 用 token 建立 headUrl 映射
            const headUrlMap = {};
            detailRes.data.list.forEach((item) => {
              if (item.token && item.headUrl) {
                headUrlMap[item.token] = item.headUrl;
              }
            });
            resumeList.value = list.map((item) => ({
              ...item,
              headUrl: item.headUrl || headUrlMap[item.token] || '',
            }));
          } else {
            resumeList.value = list;
          }
        })
        .catch(() => {
          resumeList.value = list;
        });
    }
  });
};

const companyInfo = reactive({ name: '', status: 0 });
const getCompanyInfo = () => {
  fetchCompanySimple().then((res) => {
    if (res.code == 0 && res.data) {
      companyInfo.name = res.data.name;
      companyInfo.status = res.data.status;
    }
  });
};

const jdInput = ref(null);
const handleUploadClick = () => {
  jdInput.value && jdInput.value.click();
};

const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;
  // 打开图像剪裁模态框
  selectedImageFile.value = file;
  cropperVisible.value = true;
};

const handleCropperConfirm = (compressedFile) => {
  isUploading.value = true;

  const formData = new FormData();
  formData.append('file', compressedFile);
  formData.append('folder', 1);

  upload(formData)
    .then((res) => {
      isUploading.value = false;
      cropperVisible.value = false;
      // 重置文件输入框
      if (jdInput.value) {
        jdInput.value.value = '';
      }

      if (res.code == 0) {
        message.success(res.msg);
        formState.headUrl = res.data.fileUrl;
      } else {
        message.error(res.msg);
      }
    })
    .catch((error) => {
      isUploading.value = false;
      cropperVisible.value = false;
      // 重置文件输入框
      if (jdInput.value) {
        jdInput.value.value = '';
      }
      message.error('Upload failed, please try again');
      console.error('Upload error:', error);
    });
};

const handleCropperCancel = () => {
  cropperVisible.value = false;
  // 重置文件输入框
  if (jdInput.value) {
    jdInput.value.value = '';
  }
};

const formRef = ref(null);
const formState = reactive({
  firstName: '',
  lastName: '',
  headUrl: '',
  nickName: '',
  useNicknameInResume: '',
});

const isSubmitDisabled = ref(false);
const handleUpadateUser = () => {
  formRef.value.validate().then(() => {
    isSubmitDisabled.value = true;
    updateUserInfo(formState).then((res) => {
      isSubmitDisabled.value = false;
      if (res.code == 0) {
        message.success(res.msg);
        window.location.reload();
      } else {
        message.error(res.msg);
      }
    });
  });
};

const setDefaultImage = (event, type) => {
  if (type === 'seeker') {
    event.target.src = require('@/assets/images/avatar.svg');
  } else {
    event.target.src = require('@/assets/images/avatar_recruiter.svg');
  }
};

const BusinessVerifyModalRef = ref(null);
const handleOpenBusinessVerifyModal = () => {
  BusinessVerifyModalRef.value.open();
};

const handleVerifySuccess = () => {
  window.location.reload();
};

const resumeModalVisible = ref(false);
const resumePreviewToken = ref('');
const handleOpenRusumeDetail = (item) => {
  resumeModalVisible.value = true;
  resumePreviewToken.value = item.token;
};

const handleLinkToEditResume = () => {
  fetchResumeInfo().then((res) => {
    if (res.code == 0) {
      if (!res.data || !res.data.jobStatus || !res.data.city) {
        handleOpenResumeGuideModal();
      } else {
        router.push({
          name: 'EditResume',
        });
      }
    } else {
      message.error(res.msg);
    }
  });
};

const ResumeGuideModalRef = ref(null);
const handleOpenResumeGuideModal = () => {
  ResumeGuideModalRef.value.open();
};

onMounted(() => {
  getUserCenterInfo();
});
</script>

<style lang="less">
.user_center_modal {
  color: #05644f;
  font-size: 16px;
  .ant-modal-content {
    border-radius: 20px;
  }
  .ant-modal-title {
    color: #05644f;
    font-size: 20px;
    font-weight: bold;
    line-height: normal;
  }
  .ant-modal-close-icon {
    color: #05644f;
  }
  .switch_content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .switch_icon {
      width: 80px;
      height: 80px;
      margin: 20px 0;
    }
    .text {
      font-size: 16px;
      color: #05644f;
      margin-bottom: 30px;
      font-weight: bold;
    }
  }
  .btn_wrapper {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0 20px;
    gap: 20px;
  }
  .confirm_btn,
  .cancel_btn {
    background: #05644f;
    border-radius: 100px;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    line-height: normal;
    display: block;
    flex: 1;
    padding: 10px 20px;
    height: auto;
    margin-top: 20px;
    border: none;
    &.cancel_btn {
      background: rgba(5, 100, 79, 0.3);
      color: #fff;
    }
    &:hover {
      background: #05644f;
      color: #fff;
    }
  }
  .avatar_wrapper {
    text-align: center;
    margin: 48px auto;
    .avatar {
      margin: 20px auto 10px;
      border-radius: 50%;
      border: 1px solid rgba(5, 100, 79, 0.3);
      width: 100px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        cursor: pointer;
        object-fit: cover;
      }
      .avatar_loading {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.8);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        .loading_spinner {
          width: 40px;
          height: 40px;
          border: 4px solid rgba(5, 100, 79, 0.2);
          border-top: 4px solid #05644f;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
      }
    }
    .update {
      color: #0256ff;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      margin-top: 8px;
    }
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .modal_form {
    .ant-input {
      border: 1px solid rgba(5, 100, 79, 0.5);
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
      border-radius: 16px;
      padding: 10px;
      font-size: 14px;
      color: #05644f;
    }
    .ant-input::placeholder {
      color: rgba(5, 100, 79, 0.33);
    }
    .flex_box {
      display: flex;
      justify-content: space-between;
      margin-bottom: 0;
      &:last-child {
        margin-bottom: 0;
      }
      .ant-form-item {
        flex: 1;
        margin-right: 20px;
        margin-bottom: 24px;
        &:last-child {
          margin-right: 0;
        }
      }
      .switch_item {
        padding-top: 0;
        .ant-switch.ant-switch-checked {
          background-color: #05644f;
        }
        .switch_tips {
          font-size: 12px;
          margin-left: 8px;
          color: rgba(61, 61, 61, 0.5);
        }
      }
    }
  }
}
.resume_detail_modal {
  position: relative;
  .ant-modal-content {
    border-radius: 20px;
  }
  .action_wrapper {
    position: absolute;
    right: -120px;
    top: 0;
    background: #b8dfc8;
    box-sizing: border-box;
    border: 1px solid rgba(5, 100, 79, 0.5);
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 100px;
    padding: 15px;
    color: #05644f;
    .item {
      text-align: center;
      cursor: pointer;
      border-top: 1px solid rgba(5, 100, 79, 0.25);
      padding: 10px 0;
      &:first-child {
        border-top: none;
      }
      p {
        margin: 10px 0;
      }
      img {
        width: 24px;
        height: 24px;
      }
    }
  }
}
@media (max-width: 640px) {
  // 弹窗固定 400px 宽在 360px 手机上会溢出，max-width 可压住 a-modal 的内联 width
  .user_center_modal {
    max-width: calc(100vw - 32px);
    top: 24px;
    .btn_wrapper {
      padding: 0;
    }
    // 姓名/昵称两个一行的表单项改为上下排列，避免输入框被挤得无法输入
    .modal_form .flex_box {
      flex-direction: column;
      .ant-form-item {
        margin-right: 0;
      }
    }
  }
  // 简历详情弹窗：宽度跟随视口，top 已统一收敛到 ResumePreview.vue
  .resume_detail_modal {
    width: calc(100vw - 24px) !important;
  }
}
</style>

<style lang="less" scoped>
.container {
  position: relative;
  max-width: 760px;
  margin: 0 auto;
  padding: 80px 0 100px;
  .loading_wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 400px;
    .loading_spinner {
      width: 40px;
      height: 40px;
      border: 4px solid rgba(5, 100, 79, 0.2);
      border-top: 4px solid #05644f;
      border-radius: 50%;
      animation: spin 1s linear infinite;
      margin-bottom: 20px;
    }
    .loading_text {
      color: #05644f;
      font-size: 16px;
    }
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  span img {
    width: 18px;
    height: 18px;
    margin-left: 8px;
    cursor: pointer;
  }
  .switch_btn {
    position: absolute;
    top: 72px;
    right: 40px;
    padding: 10px 25px;
    color: #fff;
    background: #05644f;
    cursor: pointer;
    z-index: 10;
    border-radius: 25px 25px 0 0;
    font-size: 12px;
    img {
      width: 15px;
      height: 15px;
      margin-left: 8px;
    }
  }
  .user_section {
    margin: 30px auto;
    border-radius: 20px;
    background: #ffffff;
    box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.05);
    padding: 30px;
    position: relative;
    width: 760px;
    .action_btn {
      margin-left: auto;
      position: absolute;
      right: 30px;
      cursor: pointer;
      top: calc(50% - 10px);
      color: rgba(5, 100, 79, 0.5);
      text-decoration: none;
      font-size: 12px;
      img {
        width: 20px;
        height: 20px;
        margin-left: 5px;
      }
    }
    .resume_score {
      color: #05644f;
      .score {
        margin-left: 10px;
        font-size: 18px;
        font-weight: bold;
        vertical-align: middle;
      }
    }
    .job {
      color: #05644f;
      .count {
        margin-right: 10px;
        font-size: 24px;
        font-weight: 500;
      }
    }
    .tip_icon {
      width: 48px;
      height: 48px;
      margin-right: 20px;
    }
    .tip {
      color: rgba(61, 61, 61, 0.5);
      font-size: 14px;
    }
  }
  .user_info,
  .company_info {
    display: flex;
    width: 100%;
    .avatar {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      margin-right: 20px;
      cursor: pointer;
      object-fit: cover;
    }
    .user_info_content {
      flex: 1;
    }
    .name {
      font-size: 18px;
      font-weight: 500;
      cursor: pointer;
      &.edit {
        cursor: pointer;
        color: #05644f;
      }
    }
    .count_wrapper {
      display: flex;
      align-items: center;
      margin-top: 10px;
      margin-left: -8px;
      img {
        width: 16px;
        height: 16px;
        margin-right: 10px;
        vertical-align: text-top;
      }
      .count {
        font-size: 14px;
        margin-right: 24px;
        color: #3d3d3d;
      }
    }
    .company,
    .cert {
      margin-top: 15px;
      color: #05644f;
      font-size: 16px;
      font-weight: 300;
    }
    .company {
      width: 500px;
    }
    .company_icon {
      width: 64px;
      height: 64px;
      margin-right: 20px;
    }
    .company_complete {
      font-size: 16px;
      font-weight: 500;
      color: #05644f;
      cursor: auto;
    }
    .company_tip {
      font-size: 16px;
      font-weight: 300;
      color: #05644f;
      width: 360px;
    }
  }
  .resume_section {
    width: 760px;
    margin: 30px auto;
    padding-bottom: 50px;
    .title {
      font-size: 16px;
      font-weight: 500;
      color: #05644f;
      margin-bottom: 20px;
    }
    .resume_wrapper {
      gap: 30px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .resume_card {
        width: calc((100% - 60px) / 3);
        background-color: white;
        border-radius: 20px;
        height: fit-content;
        padding: 24px;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        transition: transform 0.3s;
        cursor: pointer;
        &:hover {
          transform: translateY(-5px);
        }
        .info_wrapper {
          display: flex;
          position: relative;
          .avatar {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            position: absolute;
            right: 0;
            object-fit: cover;
          }
          .info {
            display: flex;
            flex-wrap: wrap;
            align-content: space-around;
            .name {
              color: #3d3d3d;
              font-size: 14px;
              font-weight: 500;
              width: 100%;
              margin-bottom: 8px;
            }
            .type {
              color: #888;
              font-size: 12px;
              width: 80%;
            }
          }
        }
        .tag_wrapper {
          display: flex;
          flex-wrap: wrap;
          margin-top: 24px;
          height: 30px;
          overflow: hidden;
          .tag {
            border-radius: 100px;
            margin-right: 6px;
            margin-bottom: 6px;
            padding: 5px 8px;
            font-size: 12px;
            background: rgba(5, 100, 79, 0.1);
            color: #05644f;
            white-space: nowrap;
            &:nth-child(2n) {
              background: rgba(247, 131, 53, 0.1);
              color: #f78335;
            }
          }
        }
        .introduce {
          margin-top: 10px;
          color: #888;
          font-size: 12px;
          line-height: 20px;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
        }
        .video_wrapper {
          margin-top: 24px;
          position: relative;
          .title {
            display: flex;
            align-items: center;
            font-size: 12px;
            color: #05644f;
            font-weight: 500;
            .camera_icon {
              width: 16px;
              height: 16px;
              margin-right: 5px;
            }
          }
          .video_img {
            width: 100%;
            height: auto;
            border-radius: 10px;
            margin-top: 10px;
          }
          .video_player {
            width: 100%;
            height: auto;
            border-radius: 8px;
            margin-top: 8px;
            background: #000;
            object-fit: cover;
            display: block;
          }
          .video_duration {
            color: #ffffff;
            font-size: 12px;
            background: rgba(0, 0, 0, 0.5);
            border-radius: 4px;
            position: absolute;
            bottom: 10px;
            right: 10px;
            padding: 2px 5px;
          }
        }
      }
    }
  }
  // 手机端适配（≤640px）：卡片固定 760px 宽会溢出视口，右侧操作按钮全部跑出屏幕
  @media (max-width: 640px) {
    box-sizing: border-box;
    // 顶部留出贴在首卡右上角的 switch 页签空间（手机 header 高约 54px + 页签约 38px）
    padding: 96px 12px 40px;
    // “Switch identities”与桌面一致：绝对定位页签贴在个人信息卡片右上角
    .switch_btn {
      position: absolute;
      // 容器 padding-top 96 = 卡片顶边；页签高 38px，故 top=58 使底边与卡片顶边精确齐平
      top: 58px;
      // 卡片右缘距容器 12px，页签再内缩 20px（与桌面 40/760 等比，且避开卡片圆角）
      right: 32px;
      margin: 0;
      width: auto;
      height: 38px;
      box-sizing: border-box;
      padding: 10px 25px;
      border-radius: 25px 25px 0 0;
    }
    .user_section {
      box-sizing: border-box;
      width: auto;
      // 企业卡上有内联 margin:30px auto，必须用 !important 才能在媒体查询里覆盖
      margin: 0 auto 16px !important;
      padding: 18px 16px;
      // 绝对定位在卡片右侧的操作按钮改为卡片内独立一行右对齐
      .action_btn {
        position: static;
        top: auto;
        right: auto;
        margin: 14px 0 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
      .tip_icon {
        width: 40px;
        height: 40px;
        margin-right: 12px;
        vertical-align: middle;
      }
      .tip {
        font-size: 13px;
        vertical-align: middle;
      }
    }
    .user_info,
    .company_info {
      flex-wrap: wrap;
      // 中间文字块（求职者有 .user_info_content 类，招聘者是裸 div）允许收缩
      > div {
        flex: 1;
        min-width: 0;
      }
      .avatar {
        width: 40px;
        height: 40px;
        margin-right: 12px;
        flex-shrink: 0;
      }
      .name {
        font-size: 16px;
      }
      // 操作按钮独占第二行，加分隔线区分层级
      .action_btn {
        width: 100%;
        margin-top: 14px;
        padding-top: 14px;
        border-top: 1px solid rgba(5, 100, 79, 0.1);
      }
    }
    .user_info {
      .user_info_content {
        flex: 1;
        min-width: 0; // 允许内容收缩，长名字省略号而不是撑破卡片
        .name {
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      // 招聘者用户卡的“XX公司 Recruiter”，基础样式写死 width:500px 会撑破手机卡片
      .company {
        width: auto;
        font-size: 14px;
        margin-top: 8px;
      }
      .count_wrapper {
        margin-top: 8px;
      }
    }
    .company_info {
      > div {
        flex: 1;
        min-width: 0;
      }
      .company {
        width: auto;
        font-size: 14px;
        margin-top: 8px;
      }
      .cert {
        margin-top: 8px;
        font-size: 14px;
      }
      .company_icon {
        width: 48px;
        height: 48px;
        margin-right: 12px;
        flex-shrink: 0;
      }
      .company_tip {
        width: auto;
        font-size: 13px;
      }
    }
    // 收藏简历：桌面三列改为单列纵向列表
    .resume_section {
      width: auto;
      margin: 24px auto 0;
      padding-bottom: 0;
      .title {
        margin-bottom: 14px;
      }
      .resume_wrapper {
        flex-direction: column;
        gap: 16px;
        .resume_card {
          width: 100%;
          padding: 16px;
          &:hover {
            transform: none; // 触屏没有 hover，避免点击后残留位移
          }
        }
      }
    }
  }
}
</style>
